<template>
  <div
    class="custom-switch d-flex align-items-center rounded-pill"
    :class="{ active: isActive }"
    @click="toggleSwitch"
  >
    <div class="toggle-circle"></div>

    <span class="status-text fw-bold">
      {{ isActive ? "Aktif" : "Non Aktif" }}
    </span>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

// Mendefinisikan props untuk v-model dengan tipe String
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  editable: {
    type: Boolean,
    default: true,
  },
  modelKey: {
    type: Number,
  },
});

const emit = defineEmits(["update:modelValue", "change"]);

const ACTIVE_VALUE = "Active";
const INACTIVE_VALUE = "Inactive";

const isActive = computed(() => props.modelValue === ACTIVE_VALUE);

// Fungsi untuk mengubah status dengan mengirim nilai string
function toggleSwitch() {
  if (props.editable === true) {
    const newValue = isActive.value ? INACTIVE_VALUE : ACTIVE_VALUE;
    emit("update:modelValue", newValue);
    emit("change", { val: newValue, index: props.modelKey });
  }
}
</script>

<style scoped>
.custom-switch {
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
  width: 140px;
  user-select: none;
}

.custom-switch {
  background-color: #f0f0f0;
  color: #a0a0a0;
  justify-content: space-between;
}

.custom-switch .toggle-circle {
  height: 1.75rem;
  width: 1.75rem;
  background-color: #cccccc;
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
}

.custom-switch.active {
  background-color: #6366f1;
  color: white;
  flex-direction: row-reverse;
}

.custom-switch.active .toggle-circle {
  background-color: white;
}

.status-text {
  flex-grow: 1;
  text-align: center;
}
</style>
